export const REDUCER_NAME = "homeHighlights";
export const SET_ERROR = `${REDUCER_NAME}/SET_ERROR`;
export const SET_HOMEHIGHLIGHTS = `${REDUCER_NAME}/SET_HOMEHIGHLIGHTS`;
export const RESET_HOMEHIGHLIGHTS = `${REDUCER_NAME}/RESET_HOMEHIGHLIGHTS`;
